<template>
    <div>
        <div class="flex">
            <slot></slot>
            <a-statistic :title="item.title" :value="item.value" style="text-align: center" v-for="(item , index) in data">
                <template #suffix>
                </template>
            </a-statistic>
        </div>
    </div>
</template>

<script>
    export default {
        name: "card",
        props:["data" ],
        watch:{
            data:function(newVal,oldVal){
                this.data = newVal;
            },
        },
    }
</script>

<style scoped>
    .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box}
</style>